import { render } from "./Reporte.vue?vue&type=template&id=721db95a&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\"}"
import script from "./Reporte.vue?vue&type=script&lang=js"
export * from "./Reporte.vue?vue&type=script&lang=js"

import "./Reporte.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script